import React from "react";
import { TextField, InputAdornment, makeStyles } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 50, // Pill-shaped like Gxon
            backgroundColor: theme.palette.mode === "light" ? "#F9FAFB" : "#1F2937",
            paddingLeft: theme.spacing(2),
            "& fieldset": {
                borderColor: "transparent",
            },
            "&:hover fieldset": {
                borderColor: theme.palette.mode === "light" ? "#E5E7EB" : "#374151",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
                borderWidth: 2,
            },
        },
        "& .MuiOutlinedInput-input": {
            padding: "10px 14px 10px 0",
            fontSize: "0.875rem",
        },
    },
    searchIcon: {
        color: theme.palette.text.secondary,
    },
}));

const SearchBar = ({ placeholder = "Search anything...", value, onChange, ...props }) => {
    const classes = useStyles();

    return (
        <TextField
            className={classes.root}
            variant="outlined"
            fullWidth
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon className={classes.searchIcon} />
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    );
};

export default SearchBar;
